import login from '../../../api/profile/login'

// initial state
const state = {
  loginInfo: null
}

// getters
const getters = {
  loginInfo: (state, getters) => {
    let staticState = state.loginInfo
    if (staticState != null) {
      return staticState
    }
    var info = null
    if (process.browser) {
      info = sessionStorage.getItem('loginInfo')
      if (info === null || info === undefined || info === 'undefined' || info === 'null') {
        return null
      }
    }
    return JSON.parse(info)
  }
}

// actions
const actions = {
  checkLogin ({ commit }) {
    commit('checkLogin')
  },
  login ({ commit }, data) {
    if (process.browser) {
      sessionStorage.removeItem('loginInfo')
    }
    return new Promise((resolve, reject) => {
      login.login(data)
        .then(res => {
          commit('setLoginInfo', res)
          resolve()
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  signup ({ commit }, data) {
    if (process.browser) {
      sessionStorage.removeItem('loginInfo')
    }
    return new Promise((resolve, reject) => {
      login.signup(data)
        .then(res => {
          commit('setLoginInfo', res)
          resolve()
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  register ({ commit }, data) {
    return new Promise((resolve, reject) => {
      login.register(data)
        .then(res => {
          resolve(res)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  forgotpassword ({ commit }, data) {
    return new Promise((resolve, reject) => {
      login.forgotpassword(data)
        .then(res => {
          resolve(res)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  forgotPasswordCheck ({ commit }, data) {
    return new Promise((resolve, reject) => {
      login.forgotPasswordCheck(data)
        .then(res => {
          commit('setLoginInfo', res)
          resolve(res)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  resendEmail ({ commit }, data) {
    return new Promise((resolve, reject) => {
      login.resendEmail(data)
        .then(res => {
          resolve()
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  validateCode ({ commit }, data) {
    return new Promise((resolve, reject) => {
      login.validateCode(data)
        .then(res => {
          resolve(res)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  logout ({ commit }) {
    return new Promise((resolve, reject) => {
      login.logout()
        .then(res => {
          if (process.browser) {
            sessionStorage.removeItem('loginInfo')
          }
          commit('setLoginInfo', null)
          resolve()
        })
        .catch((error) => {
          if (process.browser) {
            sessionStorage.removeItem('loginInfo')
          }
          reject(error)
        })
    })
  }
}

// mutations
const mutations = {
  setLoginInfo (state, res) {
    if (res === null) {
      if (process.browser) {
        sessionStorage.removeItem('loginInfo')
      }
      state.loginInfo = null
    } else {
      if (process.browser) {
        sessionStorage.setItem('loginInfo', JSON.stringify(res))
      }
      state.loginInfo = res
    }
  },
  checkLogin (state) {
    if (state.loginInfo === null) {
      if (process.browser) {
        const info = sessionStorage.getItem('loginInfo')
        if (info !== null && info !== undefined && info !== 'undefined' && info !== 'null') {
          state.loginInfo = JSON.parse(info)
        }
      }
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/profile/login.js